module.exports = __webpack_public_path__ + "static/media/motorencapsulado6.31b10687.pdf";